import React, { Component } from 'react';
import { Grid } from '@mui/material';
import CurrencyDisplay from './CurrencyDisplay';

class DisplayMenu extends Component {
  render() {
    const { name, qty, amount } = this.props;

    return (
      <Grid
        item
        container
        direction="row"
        gap={1}
        style={{ marginBottom: '4px', fontSize: '14px', fontWeight: 'bold' }}
      >
        <Grid item xs alignItems="center">
          {name}
        </Grid>

        <Grid item alignItems="center" justifyContent={'center'}>
          x{qty}
        </Grid>
        <Grid item alignItems="center" style={{ width: '92px', textAlign: 'right' }}>
          <CurrencyDisplay amount={amount} size="small" />
        </Grid>
      </Grid>
    );
  }
}

export default DisplayMenu;
